import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';
import './styles.scss';
import { Modal } from 'flowbite';

const url = 'https://wr-lumis3d.lumiscaphe.com/Snapshot'; // URL de l'API Lumiscaphe
const database = '6e068b1d-d7eb-4e40-9583-54b27de7c30e'; // ID de la base de données Lumiscaphe
const loader = document.getElementById('loader');
const splideList = document.getElementById('splide-list');
const splideListMain = document.getElementById('splide-list-main');

const decorDatas = ['Airport', 'Hangar', 'Sky Sunrise', 'Sky Sunset', 'Studio'];
const doorDatas = ['Closed', 'Opened'];
const leatherDatas = ['Leather genuine black', 'Leather genuine white', 'Leather synth black', 'Leather synth white'];
const liveryDatas = ['TBM:Alize', 'TBM:Meltem', 'TBM:Mistral', 'TBM:Sirocco', 'TBM:Zephyr'];
const stickerDatas = ['Black'];
const versionDatas = ['TBM_960'];

let configurations = {
    'Decor': [decorDatas[0]],
    'Door': [doorDatas[0]],
    'Leather': [leatherDatas[0]],
    'Lighting ceiling': false,
    'Lighting mood 960': false,
    'Livery': [liveryDatas[3]],
    'Material': ['tiles'],
    'Stickers': [stickerDatas[0]],
    'Storage left': false,
    'Storage right': false,
    'Version': [versionDatas[0]]
};

let finalConfiguration = updateConfig(configurations);
let currentNumberCamera = 0;

const modal = new Modal(document.getElementById('default-modal'));
document.getElementById('zoneA').addEventListener('click', () => {
    modal.show();
});


// Fonction pour créer la structure de données à envoyer
function createData() {
    return {
        "scene": [
            {
                "database": database,
                "configuration": finalConfiguration.join('/'),
            }
        ],
        "mode": {
            "images": {
                "cameraGroup": "925aa549-37b6-4fce-afbd-3439d07a5c8b"
            }
        },
        "renderParameters": {
            "width": 1920,
            "height": 1080,
            "antialiasing": false,
            "superSampling": "2"
        },
        "encoder": {
            "jpeg": {
                "quality": 100
            }
        }
    };
}

// Fonction pour précharger une image
function preloadImage(url) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);  // Image préchargée, on la renvoie
        img.onerror = reject;  // Erreur lors du chargement
        img.src = url;  // Déclenche le chargement de l'image
    });
}

// Fonction principale pour récupérer les données et gérer l'affichage des images
function fetchData() {
    const data = createData();

    // Afficher le loader
    loader.classList.remove('hidden');

    fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
    })
        .then(response => response.json())
        .then(data => {
            // Précharge toutes les nouvelles images avant de les afficher
            const imagePromises = data.map(camera => preloadImage(camera.url));

            // Attendre que toutes les images soient préchargées
            Promise.all(imagePromises)
                .then((loadedImages) => {
                    // Tout est préchargé, on peut maintenant remplacer les anciennes images

                    splideList.innerHTML = '';
                    splideListMain.innerHTML = '';

                    // Ajouter les miniatures (thumbnails)
                    loadedImages.forEach((thumbImg, index) => {
                        const img = thumbImg.cloneNode();

                        const splideSlide = document.createElement('li');
                        splideSlide.classList.add('splide__slide', 'rounded-lg', 'overflow-hidden');
                        thumbImg.alt = 'Image de la caméra';
                        splideSlide.appendChild(thumbImg);
                        splideList.appendChild(splideSlide);

                        const splideSlideMain = document.createElement('li');
                        splideSlideMain.classList.add('splide__slide', 'rounded-lg', 'overflow-hidden');
                        splideSlideMain.appendChild(img);
                        splideListMain.appendChild(splideSlideMain);
                    });

                    var main = new Splide('#main-slider', {
                        start: currentNumberCamera,
                        type: 'fade',
                        rewind: true,
                        pagination: false,
                        arrows: false,
                    });

                    main.on('move', function (splide, newIndex) {
                        currentNumberCamera = Number(splide);
                    });

                    var thumbnails = new Splide('#thumbnail-slider', {
                        start: currentNumberCamera,
                        fixedWidth: 100,
                        fixedHeight: 60,
                        gap: 10,
                        rewind: true,
                        pagination: false,
                        focus: 'center',
                        isNavigation: true,
                        breakpoints: {
                            600: {
                                fixedWidth: 60,
                                fixedHeight: 44,
                            },
                        },
                    });

                    thumbnails.on('move', function (splide, newIndex) {
                        currentNumberCamera = Number(splide);
                    });

                    main.sync(thumbnails);
                    main.mount();
                    thumbnails.mount();

                    // Cacher le loader
                    loader.classList.add('hidden');
                })
                .catch(error => {
                    console.error('Erreur lors du chargement des images :', error);
                });
        })
        .catch(error => {
            console.error('Erreur lors du chargement des données :', error);
        });
}

// Appelle fetchData pour la première fois
fetchData();

const decors = document.getElementById('decors');
decors.addEventListener('click', changeData.bind(null, 'Decor'));

const doors = document.getElementById('doors');
doors.addEventListener('click', changeData.bind(null, 'Door'));

const leathers = document.getElementById('leathers');
leathers.addEventListener('click', changeData.bind(null, 'Leather'));

const lightingCeiling = document.getElementById('lighting-ceiling');
lightingCeiling.addEventListener('click', function (event) {
    const button = event.target;
    changeData('Lighting ceiling', button.value);
    changeButton(button, button.value);
});

const lightingMood960 = document.getElementById('lighting-mood-960');
lightingMood960.addEventListener('click', function (event) {
    changeData('Lighting mood 960', event);
    const button = event.target;
    changeButton(button, button.value);
});

const liveries = document.getElementById('liveries');
liveries.addEventListener('click', changeData.bind(null, 'Livery'));

const stickers = document.getElementById('stickers');
stickers.addEventListener('click', changeData.bind(null, 'Stickers'));

function changeData(key, event) {
    if (event === 'true' || event === 'false') {
        configurations[key] = event === 'true';
    } else {
        configurations[key] = [event.target.value];
    }

    finalConfiguration = updateConfig(configurations);
    fetchData();
}

function updateConfig(configurations) {
    return Object.keys(configurations).reduce((acc, key) => {
        const value = configurations[key];

        if (value === true) {
            acc.push(key);
        } else if (Array.isArray(value) && value.length > 0) {
            acc = acc.concat(value.map(v => `${key}.${v}`));
        }

        return acc;
    }, []);
}

function changeButton(button, value) {
    if (value === 'true') {
        button.value = 'false';
        button.classList.remove('bg-red-500');
        button.classList.remove('border-red-700');
        button.classList.add('bg-green-500');
        button.classList.add('border-green-700');
    } else {
        button.value = 'true';
        button.classList.remove('bg-green-500');
        button.classList.remove('border-green-700');
        button.classList.add('bg-red-500');
        button.classList.add('border-red-700');
    }
}

document.getElementById('save-btn').addEventListener('click', async () => {
    const code = document.getElementById('new-code').value;
    const model = document.getElementById('model').value;
    const color = document.getElementById('color').value;

    const config = {
        model,
        color,
    };

    try {
        const response = await fetch('/api/configuration', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ code, config }),
        });

        const message = await response.text();
        alert(message);
    } catch (error) {
        console.error('Erreur lors de l\'enregistrement:', error);
    }
});

document.getElementById('retrieve-btn').addEventListener('click', async () => {
    const code = document.getElementById('code').value;

    try {
        const response = await fetch(`/api/configuration/${code}`);

        if (response.ok) {
            const config = await response.json();
            alert(`Modèle: ${config.model}, Couleur: ${config.color}`);
        } else {
            alert('Configuration non trouvée');
        }
    } catch (error) {
        console.error('Erreur lors de la récupération:', error);
    }
});
